import { type CreateOrUpdateTagModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<Pick<CreateOrUpdateTagModel, 'name'>>]: number
} = {
  name: 150,
}
